import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/dark.css';
import App from './App';
import { initGoogleAnalytics, captureAttribution, initClickTracking } from './analytics';

// Initialize Google Analytics (GA4) from environment variable
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
if (typeof window !== 'undefined') {
  if (GA_MEASUREMENT_ID) {
    initGoogleAnalytics(GA_MEASUREMENT_ID);
  }
  captureAttribution();
  initClickTracking();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 